<div class="row">
  <div class="col">
    <p-table [totalRecords]="trainingRecords?.length" #dt [value]="trainingRecords" styleClass="p-datatable-striped p-datatable-responsive-eca"
             [scrollable]="!isOnMobile &&    trainingRecords?.length > 5" scrollHeight="500px" dataKey="id"
             [responsive]="true" [columns]="columns"
             [globalFilterFields]="['operativeFirstName', 'operativeLastName', 'achievedOn.dateTime','validTo.dateTime', 'trainingTypeName', 'trainingExtraDescription' , 'totalObservations', 'categoryName', 'cpdHour']">
      <ng-template pTemplate="caption">
        <div class="row d-flex justify-content-between align-items-center">
          <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
            <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
              <div class="col-auto">
                <h5 class="eca-primary-text h5-relative-font-size" *ngIf="showHeaderText">
                  <span *ngIf="trainingRecords"> {{ trainingRecords.length }}</span>
                  Training Records
                </h5>
              </div>
            </div>
          </div>
          <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
            <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
              <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-8">
                     <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                       <input pInputText type="text" class="form-control" id="ctrlSearchInput"
                              placeholder="Search All"
                              (input)="dt.filterGlobal($event.target.value, 'contains')">
                        </span>
              </div>
              <div class="col-auto">
                <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary" (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                <app-eca-ghost-btn btnIcon="file-excel" btnText="Training Matrix" btnType="primary" (btnClicked)="exportTrainingMatrix()"></app-eca-ghost-btn>
              </div>
            </div>
          </div>
        </div>


      </ng-template>
      <ng-template pTemplate="header">
        <tr class="eca-grey-bg">
          <th style="width: 10%;" pSortableColumn="operativeFirstName">
            Operative First Name
            <p-sortIcon field="operativeFirstName"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="operativeLastName">
            Operative Last Name
            <p-sortIcon field="operativeLastName"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="achievedOn.dateTime">
            Achieved On
            <p-sortIcon field="achievedOn.dateTime"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="validTo.dateTime">
            Valid To
            <p-sortIcon field="validTo.dateTime"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="trainingTypeName">
            Training Course
            <p-sortIcon field="trainingTypeName"></p-sortIcon>
          </th>
          <th style="width: 19%;" pSortableColumn="trainingExtraDescription">
            Description
            <p-sortIcon field="trainingExtraDescription"></p-sortIcon>
          </th>
          <th style="width: 10%;" pSortableColumn="categoryName">
            Category Name
            <p-sortIcon field="totalDocuments"></p-sortIcon>
          </th>
          <th style="width: 7%;" pSortableColumn="totalObservations">
            Observations
            <p-sortIcon field="totalObservations"></p-sortIcon>
          </th>

          <th style="width: 4%" pSortableColumn="cpdHours">
            CPD Hours
            <p-sortIcon field="cpdHours"></p-sortIcon>
          </th>
          <th style="width: 10%;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-trainingRecord let-columns="columns" style="margin: 15px;">
        <tr>
          <td *ngFor="let col of columns">

            <span class="p-column-title">{{col.header}}: </span>
            <label>
              <span *ngIf="col.type=== 'link'">
                <a [routerLink]="'/operative/' + trainingRecord?.operativeId">{{ trainingRecord[col.field] }} </a>
              </span>
              <span *ngIf="col.type=== 'text'">
                {{trainingRecord[col.field]}}
              </span>
              <span *ngIf="col.type === 'date'">
                {{trainingRecord[col.field]?.dateTime | date:'dd/MM/yyyy'}}
              </span>
            </label>
            <label *ngIf="col.type === 'html'" [innerHTML]="trainingRecord[col.field]">
            </label>
          </td>
          <td>
            <app-eca-row-menu (viewBtnClicked)="viewTrainingRecord(trainingRecord)"
                              [rowMenuItems]="rowMenuItems"
                              [contextItem]="trainingRecord">
            </app-eca-row-menu>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
